/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R4_PurposeInputs */

const tr_cerez_s3_r4_purpose = /** @type {(inputs: Cerez_S3_R4_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dil tercihiniz; yalnızca bir dil seçtiğinizde ya da hesabınızda kayıtlı dil (ilk olarak kayıt sırasında tarayıcınızın dilinden alınır) bu tarayıcıdaki dilden farklıysa yazılır`)
};

const en_cerez_s3_r4_purpose = /** @type {(inputs: Cerez_S3_R4_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your language preference; written only when you choose a language, or when the language saved in your account (first taken from your browser language at sign-up) differs from the one shown in this browser`)
};

const de_cerez_s3_r4_purpose = /** @type {(inputs: Cerez_S3_R4_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Spracheinstellung; wird nur geschrieben, wenn Sie eine Sprache wählen oder wenn die in Ihrem Konto gespeicherte Sprache (zuerst bei der Registrierung aus der Browsersprache übernommen) von der in diesem Browser angezeigten abweicht`)
};

const ru_cerez_s3_r4_purpose = /** @type {(inputs: Cerez_S3_R4_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш выбор языка; записывается, только когда вы выбираете язык или когда язык, сохранённый в учётной записи (сначала берётся из языка браузера при регистрации), отличается от языка, показанного в этом браузере`)
};

/**
* | output |
* | --- |
* | "Your language preference; written only when you choose a language, or when the language saved in your account (first taken from your browser language at sign..." |
*
* @param {Cerez_S3_R4_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r4_purpose = /** @type {((inputs?: Cerez_S3_R4_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R4_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r4_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r4_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r4_purpose(inputs)
	return tr_cerez_s3_r4_purpose(inputs)
});